import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'glucose',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patient-glucose-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.glucose-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "index-habits" */ '@/modules/patient-profile/glucose/views/Create.vue')
        }
    ]
}